// src/private/src/pages/app/clients/ClientZipsPage.jsx
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import api from '@src/api/clients';

export default function ClientZipsPage() {
  const [clientZips, setClientZips] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchClientZips = () => {
    setLoading(true);
    api.request({
      url: 'dashboard/client-zips/',
      method: 'GET'
    })
      .then(res => setClientZips(res.data))
      .catch(err => console.error("Failed to fetch client zips:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchClientZips();
  }, []);

  const handleImportClick = () => {
    const spreadsheet_id = '1jD65U3p16pW2sg3KW_00_UsHMYaxVvKM7xSM2AV8DhE';
    const range_name = 'VerticalZips!A2:F';
  
    api.request({
      url: 'dashboard/clients/client-zips/import/',
      method: 'POST',
      data: {
        spreadsheet_id, // directly pass the data object, Axios will handle JSON
        range_name
      },
      headers: {
        'Content-Type': 'application/json',  // Make sure the content-type is set
      }
    })
      .then(() => {
        alert('📥 Import started!');
        fetchClientZips(); // refresh table if needed
      })
      .catch((err) => {
        console.error('❌ Failed to trigger import:', err);
        alert('❌ Failed to trigger import.');
      });
  };
  
  
  
  
  

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">
          Client Zips
        </Typography>
        <Button variant="contained" onClick={handleImportClick}>
          Import from Google Sheet
        </Button>
      </Box>

      <Card>
        <CardContent>
          {loading ? (
            <Box display="flex" justifyContent="center" my={4}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Client</TableCell>
                    <TableCell>ZIP</TableCell>
                    <TableCell>Vertical</TableCell>
                    <TableCell>Territory</TableCell>
                    <TableCell>Calendar</TableCell>
                    <TableCell>Active</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clientZips.map(zip => (
                    <TableRow key={zip.id}>
                      <TableCell>{zip.client_name}</TableCell>
                      <TableCell>{zip.zip}</TableCell>
                      <TableCell>{zip.vertical_name}</TableCell>
                      <TableCell>{zip.territory_name || '-'}</TableCell>
                      <TableCell>{zip.calendar || '-'}</TableCell>
                      <TableCell>{zip.active ? '✅' : '❌'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
